var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIconPatternFly2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 391.158,
    height: 175.758,
    viewBox: "0 0 391.158 175.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_us7",
    transform: "translate(-1563.329 -1596.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172510",
    "data-name": "\\uADF8\\uB8F9 172510",
    transform: "translate(14.072 24.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121599",
    "data-name": "\\uD328\\uC2A4 121599",
    d: "M2965.334,856.425a.9.9,0,0,0-1.261.171c-1.071,1.408-2.268,2.836-3.557,4.244q-.366.4-.753.81a.9.9,0,1,0,1.309,1.235q.395-.419.771-.828c1.327-1.449,2.559-2.919,3.663-4.37A.9.9,0,0,0,2965.334,856.425Z",
    transform: "translate(-1308.834 864.171)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121600",
    "data-name": "\\uD328\\uC2A4 121600",
    d: "M2763.92,962.758c-2.16.266-4.4.459-6.657.573a.9.9,0,0,0,.045,1.8h.046c2.3-.117,4.583-.313,6.786-.584a.9.9,0,0,0-.22-1.787Z",
    transform: "translate(-1154.046 783)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121601",
    "data-name": "\\uD328\\uC2A4 121601",
    d: "M2873.421,929.738a63.605,63.605,0,0,1-6.01,2.848.9.9,0,1,0,.685,1.665,65.443,65.443,0,0,0,6.18-2.929.9.9,0,1,0-.855-1.584Z",
    transform: "translate(-1238.215 808.241)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121602",
    "data-name": "\\uD328\\uC2A4 121602",
    d: "M2922.291,897.656a61.359,61.359,0,0,1-5.255,4.073.9.9,0,0,0,1.023,1.481,63.226,63.226,0,0,0,5.41-4.194.9.9,0,1,0-1.178-1.36Z",
    transform: "translate(-1276.163 832.776)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121603",
    "data-name": "\\uD328\\uC2A4 121603",
    d: "M2819.823,951.287c-2.086.628-4.26,1.176-6.462,1.629a.9.9,0,0,0,.363,1.763c2.254-.464,4.481-1.025,6.619-1.669a.9.9,0,0,0-.519-1.723Z",
    transform: "translate(-1196.9 791.767)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121604",
    "data-name": "\\uD328\\uC2A4 121604",
    d: "M2540.8,933.036c-2.111-.589-4.28-1.231-6.448-1.9a.9.9,0,0,0-.534,1.719c2.184.679,4.371,1.325,6.5,1.919a.9.9,0,0,0,.484-1.734Z",
    transform: "translate(-983.932 807.128)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121605",
    "data-name": "\\uD328\\uC2A4 121605",
    d: "M2595.5,947.832c-2.135-.442-4.34-.94-6.551-1.481a.9.9,0,1,0-.428,1.748c2.233.547,4.458,1.05,6.615,1.5a.932.932,0,0,0,.183.018.9.9,0,0,0,.181-1.781Z",
    transform: "translate(-1025.579 795.519)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121606",
    "data-name": "\\uD328\\uC2A4 121606",
    d: "M2707.37,964.8c-2.176-.028-4.427-.122-6.692-.28a.9.9,0,1,0-.125,1.8c2.3.16,4.584.256,6.793.284h.012a.9.9,0,0,0,.011-1.8Z",
    transform: "translate(-1110.84 781.655)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121607",
    "data-name": "\\uD328\\uC2A4 121607",
    d: "M2651.082,958.759c-2.165-.26-4.4-.581-6.641-.952a.9.9,0,1,0-.294,1.775c2.268.376,4.529.7,6.721.964a.882.882,0,0,0,.108.007.9.9,0,0,0,.106-1.793Z",
    transform: "translate(-1067.918 786.777)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121608",
    "data-name": "\\uD328\\uC2A4 121608",
    d: "M3161.865,593.979c-2.1,1.006-4.124,2.083-6.028,3.2a.9.9,0,0,0,.911,1.553c1.861-1.092,3.845-2.145,5.9-3.13a.9.9,0,0,0-.78-1.623Z",
    transform: "translate(-1458.107 1064.105)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121609",
    "data-name": "\\uD328\\uC2A4 121609",
    d: "M3213.438,572.992c-2.19.712-4.346,1.487-6.406,2.3a.9.9,0,1,0,.662,1.673c2.026-.8,4.146-1.563,6.3-2.263a.9.9,0,1,0-.556-1.712Z",
    transform: "translate(-1497.028 1080.066)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121610",
    "data-name": "\\uD328\\uC2A4 121610",
    d: "M3263.619,562.276c-.809.2-1.66.41-2.546.644a.9.9,0,0,0,.229,1.77.913.913,0,0,0,.23-.03c.874-.231,1.712-.442,2.51-.635a.9.9,0,1,0-.424-1.749Z",
    transform: "translate(-1538.135 1088.219)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121611",
    "data-name": "\\uD328\\uC2A4 121611",
    d: "M3115.245,622.851a59.722,59.722,0,0,0-5.311,4.328.9.9,0,1,0,1.217,1.325,58.157,58.157,0,0,1,5.151-4.2.9.9,0,1,0-1.057-1.456Z",
    transform: "translate(-1423.242 1042.166)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121612",
    "data-name": "\\uD328\\uC2A4 121612",
    d: "M2997.788,807.376a.9.9,0,0,0-1.182.471,57.14,57.14,0,0,1-2.941,5.945.9.9,0,0,0,1.562.895,58.845,58.845,0,0,0,3.032-6.128A.9.9,0,0,0,2997.788,807.376Z",
    transform: "translate(-1334.766 901.467)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121613",
    "data-name": "\\uD328\\uC2A4 121613",
    d: "M3020.394,754.828a.9.9,0,0,0-1.187.46c-.959,2.175-1.755,4.212-2.554,6.282a.9.9,0,1,0,1.679.648c.79-2.049,1.578-4.065,2.521-6.2A.9.9,0,0,0,3020.394,754.828Z",
    transform: "translate(-1352.33 941.516)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121614",
    "data-name": "\\uD328\\uC2A4 121614",
    d: "M3076.09,661.211c-1.573,1.74-3.056,3.48-4.407,5.173a.9.9,0,1,0,1.406,1.123c1.329-1.664,2.788-3.376,4.336-5.089a.9.9,0,0,0-1.335-1.207Z",
    transform: "translate(-1394.164 1013.027)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121615",
    "data-name": "\\uD328\\uC2A4 121615",
    d: "M3044.74,705.415a.9.9,0,0,0-1.25.239c-1.314,1.934-2.483,3.833-3.575,5.806a.9.9,0,1,0,1.575.871c1.065-1.925,2.206-3.778,3.489-5.666A.9.9,0,0,0,3044.74,705.415Z",
    transform: "translate(-1370.018 979.232)",
    fill: "#d7e0ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172511",
    "data-name": "\\uADF8\\uB8F9 172511",
    transform: "translate(1740.668 1596.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-2",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-3",
    "data-name": "mail_icon",
    transform: "translate(26.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-4",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-5",
    "data-name": "mail_icon",
    transform: "translate(53.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-6",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-7",
    "data-name": "mail_icon",
    transform: "translate(80.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-8",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-9",
    "data-name": "mail_icon",
    transform: "translate(107.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-10",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-11",
    "data-name": "mail_icon",
    transform: "translate(133.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-12",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-13",
    "data-name": "mail_icon",
    transform: "translate(160.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-14",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-15",
    "data-name": "mail_icon",
    transform: "translate(187.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-16",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-17",
    "data-name": "mail_icon",
    transform: "translate(0 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-18",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-19",
    "data-name": "mail_icon",
    transform: "translate(26.759 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-20",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-21",
    "data-name": "mail_icon",
    transform: "translate(53.516 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-22",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-23",
    "data-name": "mail_icon",
    transform: "translate(80.273 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-24",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-25",
    "data-name": "mail_icon",
    transform: "translate(107.03 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-26",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-27",
    "data-name": "mail_icon",
    transform: "translate(133.789 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-28",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-29",
    "data-name": "mail_icon",
    transform: "translate(160.546 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-30",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-31",
    "data-name": "mail_icon",
    transform: "translate(187.303 25.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-32",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-33",
    "data-name": "mail_icon",
    transform: "translate(0 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-34",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-35",
    "data-name": "mail_icon",
    transform: "translate(26.759 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-36",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-37",
    "data-name": "mail_icon",
    transform: "translate(53.516 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-38",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-39",
    "data-name": "mail_icon",
    transform: "translate(80.273 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-40",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-41",
    "data-name": "mail_icon",
    transform: "translate(107.03 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-42",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-43",
    "data-name": "mail_icon",
    transform: "translate(133.789 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-44",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-45",
    "data-name": "mail_icon",
    transform: "translate(160.546 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-46",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-47",
    "data-name": "mail_icon",
    transform: "translate(187.303 51.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-48",
    "data-name": "mail_icon",
    d: "M.009,18.823s18.838-8.285,18.81-9.412S.009,0,.009,0L0,7.32S13.424,8.668,13.442,9.412,0,11.5,0,11.5Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 12.097)",
    fill: "#c6d3e4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconPatternFly2);
export default __webpack_public_path__ + "static/media/contact_us_icon_pattern_fly2.4718caa9c65360f9f6aa6866b097c20f.svg";
export { ForwardRef as ReactComponent };